
import { Card, Col, Form, Row, Space, Input, Select } from 'antd'
import { ButtonBack, ButtonSaveDraft, ButtonSubmit } from 'components/Common/Buttons';
import useTopbarTitleHooks from 'hooks/useTopbarTitleHooks';
import { useAtom } from 'jotai';
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { APP_ROUTE_PREFIX, RouteConstant } from 'routes/routesConstant';
import useDeptRepo from "../../services/repo/useDepartmentRepo";
import useOrgRepo from "../../services/repo/useOrgRepo";
import useDivRepo from "../../services/repo/useDivisionRepo";
import usePosRepo from "../../services/repo/usePositionRepo";
import useWBSRepo from "../../services/repo/useWBSRepo";
import { INIT_WBS, wbsAtom } from 'store/WBS/wbs';
import { PRIVILEGE_ID } from 'utils/AccessPermissionConfig';
import Constant from 'utils/Constants';
import CustomAlert from 'utils/CustomAlert';
import { checkErrorFormToOpenCollapse, setFieldValues } from 'utils/Helper';
import { dismissToast, errorToast, loadingToastId, successToast } from 'utils/Toast';
import { CustomFormItemText, CustomFormItemInteger, CustomFormItemSelectDropdown, CustomFormItemTextArea, CustomFormItemDate, CustomFormItemSwitch } from 'components/Common/CustomFormItem';
import SectionWbsTaskSubmission from './Section/SectionWbsTaskSubmission';
import useParamRepo from 'services/repo/useParamRepo';
// import useWBSRepo from 'services/repo/useWBSRepo';



export default function ManageTaskSubmission() {
    const { taskId } = useParams();
    const isEditMode = Boolean(taskId);
    useTopbarTitleHooks(`${isEditMode ? "Submission  Form" : "Submission  Form"} Work Breakdown Structure (WBS)`);
    const { isLoading: isLoadingGetById, getDepartmentById } = useDeptRepo(false);
    const { isLoading: isLoadingOrgList, getOrgList } = useOrgRepo(false)
    const { isLoading: isLoadingDivList, getDivisionList } = useDivRepo(false)
    const { isLoading: isLoadingDeptList, getDepartmentList } = useDeptRepo(false)
    const { isLoading: isLoadingPosList, getPositionList } = usePosRepo(false)
    const { isLoading: isLoadingWbs, submit, saveDraft, getTaskSubmissionById } = useWBSRepo(false);
    const { getParamByCategory } = useParamRepo(false);
    const { getWBSTimeUnit } = useWBSRepo(false);

    const [wbsTaskList, setWbsTaskList] = useState([]);
    const [dataField, setDataField] = useAtom(wbsAtom);
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [activeKey, setActiveKey] = useState(['1', '2']);
    const [errorList, setErrorList] = useState(false);
    const isLoadingPrivilege = useRef(true);


    const fetchCheckPrivilege = async () => {

        loadingToastId(Constant.message.loading, PRIVILEGE_ID.AddEditWbs)
        dismissToast(PRIVILEGE_ID.AddEditWbs)
        isLoadingPrivilege.current = false
    }

    const handleTaskListChange = (updatedList) => {
        console.log("🔥 Data WBS terkirim ke parent:", updatedList);
        setWbsTaskList(updatedList);
        console.log("🔥 A Data WBS terkirim ke parent:", wbsTaskList);
    };

    const fetchGetWbsById = async (id) => {
        const response = await getTaskSubmissionById({ taskId: id });
        if (response?.detail !== 'OK') return errorToast('Gagal ambil data WBS');

        const data = response.data;

        // 1. Fetch all dropdown options
        const [unitRes, freqRes, timeRes] = await Promise.all([
            getParamByCategory({ paramCategory: "wbs_output_unit" }),
            getParamByCategory({ paramCategory: "wbs_frequency_type" }),
            getWBSTimeUnit({ taskId: id }),
        ]);

        const outputUnitOptions = unitRes?.data?.map(x => ({ label: x.paramValue, value: x.paramId })) ?? [];
        const frequencyOptions = freqRes?.data?.map(x => ({ label: x.paramValue, value: x.paramId, data: x.paramData })) ?? [];
        const timeUnitOptions = timeRes?.data?.map(x => ({ label: x.wbsTuParamValue, value: x.wbsTuId, data: x.wbsTuParamData })) ?? [];


        const orgOptions = await fetchDataOrg();
        const divOptions = await fetchDataDivision(data.orgId);
        const deptOptions = await fetchDataDepartment(data.divId);
        const posOptions = await fetchDataPosition(data.deptId);

        // 3. Helper aman
        const getLabelValueObject = (options, value) =>
            Array.isArray(options)
                ? options.find(opt => opt.value === value) || { value, label: value || "-" }
                : { value, label: value || "-" };

        // 4. Barulah setFieldsValue
        form.setFieldsValue({
            orgId: getLabelValueObject(orgOptions, data.orgName),
            divId: getLabelValueObject(divOptions, data.divName),
            deptId: getLabelValueObject(deptOptions, data.deptName),
            posId: getLabelValueObject(posOptions, data.posName),
            employeeName: data.submissionUserFullName,
            posResourceTotal: data.posResourceTotal,
            orgAddress: data.orgAddress,
        });


        // 5. Simpan ke atom/global state
        setDataField(prev => ({
            ...prev,
            taskId: id,
            orgId: data.orgId,
            divId: data.divId,
            deptId: data.deptId,
            posId: data.posId,
            employeeName: data.submissionUserFullName,
            posResourceTotal: data.posResourceTotal,
            orgAddress: data.orgAddress,
        }));

        // 6. Mapping WBS Task List
        const mappedList = data.wbsContentList.map((item, index) => ({
            id: Date.now() + index,
            taskDescription: item.wbsContentTask,
            remark: item.wbsContentRemark,
            contentId: item.wbsContentId,
            wbsContentId: item.wbsContentId,
            contentNo: item.wbsContentNo,
            wbsId: item.wbsId,

            outputUnit: getLabelValueObject(outputUnitOptions, item.wbsContentOutputUnitParamId),
            outputTimeToCompleteUnit: getLabelValueObject(timeUnitOptions, item.wbsTuId),
            frequency: getLabelValueObject(frequencyOptions, item.wbsContentFrequencyTypeParamId),

            timeToComplete: Number(item.wbsContentCompletionTime ?? 0),
            outputCount: Number(item.wbsContentWorkResult ?? 0),
            serverFte: item?.wbsContentFte ? Number(item.wbsContentFte) : undefined,

            wbsCatId: item.wbsCatId ?? null,
        }));

        setWbsTaskList(mappedList);
    };


    const validateList = () => {
        return wbsTaskList.length > 0;
    };

    const syncWbsTaskListFromForm = () => {
        const values = form.getFieldsValue();
        const syncedList = wbsTaskList.map((item) => {
            const id = item.id;
            return {
                ...item,
                taskDescription: values[`taskDescription_${id}`],
                remark: values[`remark_${id}`],
                outputUnit: values[`outputUnit_${id}`],
                outputTimeToCompleteUnit: values[`outputTimeToCompleteUnit_${id}`],
                frequency: values[`frequency_${id}`],
                outputCount: values[`outputCount_${id}`],
                timeToComplete: values[`timeFinish_${id}`],
                wbsCatId: values[`wbsCatId_${id}`],
            };
        });
        return syncedList;
    };

    // const doSubmit = async () => {
    //     const extractValue = (val) => (typeof val === "object" && val !== null ? val.value : val);

    //     const updatedList = syncWbsTaskListFromForm().map((item, index) => ({
    //         wbsContentId: item.wbsContentId || "",
    //         wbsContentNo: `${index + 1}`,
    //         wbsContentTask: item.taskDescription || "",
    //         wbsContentRemark: item.remark || "",
    //         wbsContentOutputUnitParamId: extractValue(item.outputUnit) || "",
    //         wbsContentCompletionTime: String(item.timeToComplete || 0),
    //         wbsTuId: extractValue(item.outputTimeToCompleteUnit) || "",
    //         wbsContentFrequencyTypeParamId: extractValue(item.frequency) || "",
    //         wbsContentWorkResult: String(item.outputCount || 0),
    //         wbsCatId: extractValue(item.wbsCatId) || null,
    //     }));

    //     console.log("✅ Synced WBS List from Form:", updatedList);

    //     const payload = {
    //         taskId: dataField?.taskId || '',
    //         wbsContentList: updatedList
    //     };

    //     console.log("Final Payload:", JSON.stringify(payload, null, 2));

    //     try {
    //         loadingToastId(Constant.message.savingData, payload);
    //         const response = await submit(payload);
    //         dismissToast(payload);

    //         if (response?.detail === 'OK' && response?.status === 200) {
    //             successToast(Constant.message.submitDataSuccess);
    //             navigate(APP_ROUTE_PREFIX + '/' + RouteConstant.task.index, { replace: true });
    //         } else {
    //             errorToast(Constant.message.fail);
    //         }
    //     } catch (error) {
    //         dismissToast(payload);
    //         errorToast("Gagal menyimpan draft: " + (error.response?.data?.message || error.message));
    //         console.error("Save draft error:", error);
    //     }
    // };

    // const doSaveDraft = async () => {
    //     // helper to extract only dropdown value
    //     const extractValue = (val) => (typeof val === "object" && val !== null ? val.value : val);

    //     const updatedList = syncWbsTaskListFromForm().map((item, index) => ({
    //         wbsContentId: item.wbsContentId || "",
    //         wbsContentNo: `${index + 1}`,
    //         wbsContentTask: item.taskDescription || "",
    //         wbsContentRemark: item.remark || "",
    //         wbsContentOutputUnitParamId: extractValue(item.outputUnit) || "",
    //         wbsContentCompletionTime: String(item.timeToComplete || 0),
    //         wbsTuId: extractValue(item.outputTimeToCompleteUnit) || "",
    //         wbsContentFrequencyTypeParamId: extractValue(item.frequency) || "",
    //         wbsContentWorkResult: String(item.outputCount || 0),
    //         wbsCatId: extractValue(item.wbsCatId) || null,
    //     }));

    //     console.log("✅ Synced WBS List from Form:", updatedList);

    //     const payload = {
    //         taskId: dataField?.taskId || '',
    //         wbsContentList: updatedList
    //     };

    //     console.log("Final Payload:", JSON.stringify(payload, null, 2));

    //     try {
    //         loadingToastId(Constant.message.savingData, payload);
    //         const response = await saveDraft(payload);
    //         dismissToast(payload);


    //         if (response?.detail === 'OK' && response?.status === 200) {
    //             successToast(Constant.message.saveDataSuccess);
    //             navigate(APP_ROUTE_PREFIX + '/' + RouteConstant.task.index, { replace: true });
    //         } else {
    //             errorToast(Constant.message.fail);
    //         }
    //     } catch (error) {
    //         dismissToast(payload);
    //         errorToast("Gagal menyimpan draft: " + (error.response?.data?.message || error.message));
    //         console.error("Save draft error:", error);
    //     }
    // };

    const doSubmit = async () => {
        const extractValue = (val) =>
            (typeof val === "object" && val !== null ? val.value : val);

        const updatedList = syncWbsTaskListFromForm().map((item, index) => {
            // 🔹 khusus mapping wbsCatId
            let rawWbsCatId = extractValue(item.wbsCatId);

            // kalau UI masih "pilih" / "-PILIH-" / kosong → jadikan null
            if (
                rawWbsCatId === "-PILIH-" ||
                rawWbsCatId === "PILIH" ||
                rawWbsCatId === "" ||
                rawWbsCatId === undefined
            ) {
                rawWbsCatId = null;
            }

            return {
                wbsContentId: item.wbsContentId || "",
                wbsContentNo: `${index + 1}`,
                wbsContentTask: item.taskDescription || "",
                wbsContentRemark: item.remark || "",
                wbsContentOutputUnitParamId: extractValue(item.outputUnit) || "",
                wbsContentCompletionTime: String(item.timeToComplete || 0),
                wbsTuId: extractValue(item.outputTimeToCompleteUnit) || "",
                wbsContentFrequencyTypeParamId: extractValue(item.frequency) || "",
                wbsContentWorkResult: String(item.outputCount || 0),
                wbsCatId: rawWbsCatId,   // 🔹 sudah dibersihkan
            };
        });

        console.log("✅ Synced WBS List from Form:", updatedList);

        const payload = {
            taskId: dataField?.taskId || '',
            wbsContentList: updatedList
        };

        console.log("Final Payload (Submit):", JSON.stringify(payload, null, 2));

        try {
            loadingToastId(Constant.message.savingData, payload);
            const response = await submit(payload);
            dismissToast(payload);

            if (response?.detail === 'OK' && response?.status === 200) {
                successToast(Constant.message.submitDataSuccess);
                navigate(APP_ROUTE_PREFIX + '/' + RouteConstant.task.index, { replace: true });
            } else {
                errorToast(Constant.message.fail);
            }
        } catch (error) {
            dismissToast(payload);
            // (opsional) text ini bisa diganti jadi "Gagal submit" biar konsisten
            errorToast("Gagal submit: " + (error.response?.data?.message || error.message));
            console.error("Submit error:", error);
        }
    };


    const doSaveDraft = async () => {
        // helper to extract only dropdown value
        const extractValue = (val) =>
            (typeof val === "object" && val !== null ? val.value : val);

        const updatedList = syncWbsTaskListFromForm().map((item, index) => {
            // 🔹 khusus mapping wbsCatId
            let rawWbsCatId = extractValue(item.wbsCatId);

            // kalau UI pakai "-PILIH-" atau "PILIH" atau "" → jadikan null
            if (
                rawWbsCatId === "-PILIH-" ||
                rawWbsCatId === "PILIH" ||
                rawWbsCatId === "" ||
                rawWbsCatId === undefined
            ) {
                rawWbsCatId = null;
            }

            return {
                wbsContentId: item.wbsContentId || "",
                wbsContentNo: `${index + 1}`,
                wbsContentTask: item.taskDescription || "",
                wbsContentRemark: item.remark || "",
                wbsContentOutputUnitParamId: extractValue(item.outputUnit) || "",
                wbsContentCompletionTime: String(item.timeToComplete || 0),
                wbsTuId: extractValue(item.outputTimeToCompleteUnit) || "",
                wbsContentFrequencyTypeParamId: extractValue(item.frequency) || "",
                wbsContentWorkResult: String(item.outputCount || 0),

                // ⬇️ sekarang aman: kalau PILIH -> null yg dikirim
                wbsCatId: rawWbsCatId,
            };
        });

        console.log("✅ Synced WBS List from Form:", updatedList);

        const payload = {
            taskId: dataField?.taskId || '',
            wbsContentList: updatedList
        };

        console.log("Final Payload:", JSON.stringify(payload, null, 2));

        try {
            loadingToastId(Constant.message.savingData, payload);
            const response = await saveDraft(payload);
            dismissToast(payload);

            if (response?.detail === 'OK' && response?.status === 200) {
                successToast(Constant.message.saveDataSuccess);
                navigate(APP_ROUTE_PREFIX + '/' + RouteConstant.task.index, { replace: true });
            } else {
                errorToast(Constant.message.fail);
            }
        } catch (error) {
            dismissToast(payload);
            errorToast("Gagal menyimpan draft: " + (error.response?.data?.message || error.message));
            console.error("Save draft error:", error);
        }
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        CustomAlert.confirm({
            title: 'Submit WBS!',
            description: 'Are you sure you want to submit this WBS?',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            type: 'primary',
            onConfirmButton: () => doSubmit()
        });
    };

    const handleFormSaveDraft = e => {
        e.preventDefault();
        form.validateFields().then(() => {
            if (!validateList()) return errorToast('WBS task list tidak boleh kosong');
            CustomAlert.confirm({
                title: 'Save as Draft',
                description: 'Are you sure you want to save this WBS as draft?',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                type: 'primary',
                onConfirmButton: doSaveDraft
            });
        }).catch(() => errorToast(Constant.message.errorForm));
    };


    // Org dropdown
    const [orgOptions, setOrgOptions] = useState([])
    const fetchDataOrg = async () => {
        const payload = {
            pageNumber: 1,
            pageSize: 0,
            orderBy: "orgId",
            isAscending: true,
            filter: {
                orgId: null,
                orgName: "",
                status: "true",
            },
        };


        const res = await getOrgList(payload);
        if (res?.detail === 'OK' && res?.status === 200) {
            const options = res.data.content.map(item => ({
                label: item.orgName,
                value: item.orgId,
            }));
            setOrgOptions(options);
            return options; // ✅ ini WAJIB agar fetchGetWbsById bisa pakai
        } else {
            setOrgOptions([]);
            return [];
        }
    };


    const [divOptions, setDivOptions] = useState([])
    const fetchDataDivision = async (orgId) => {
        const payload = {
            pageNumber: 1,
            pageSize: 0,
            filter: {
                divCode: "",
                divName: "",
                orgId: orgId,
                divId: null,
                status: "true",
            },
            orderBy: "divCode",
            isAscending: true
        }

        const res = await getDivisionList(payload)
        if (res?.detail === 'OK' && res?.status === 200) {
            const options = res?.data?.content.map(item => ({
                value: item?.divId,
                label: item?.divName
            }));
            setDivOptions(options);
            return options;
        } else {
            setDivOptions([]);
            return [];
        }
    }

    const [deptOptions, setDeptOptions] = useState([])
    const fetchDataDepartment = async (divId) => {
        const payload = {
            pageNumber: 1,
            pageSize: 0,
            filter: {
                divId: divId,
                deptName: "",
                status: "true",
            },
            orderBy: "deptName",
            isAscending: true
        }

        const res = await getDepartmentList(payload)
        if (res?.detail === 'OK' && res?.status === 200) {
            setDeptOptions(res.data?.content.map(item => ({
                label: item.deptName,
                value: item.deptId
            })))
        } else {
            setDeptOptions([])
        }
    }

    const [positionOptions, setPositionOptions] = useState([])
    const fetchDataPosition = async (deptId) => {
        const payload = {
            pageNumber: 1,
            pageSize: 0,
            filter: {
                deptId: deptId,
                posName: "",
                status: "true"
            },
            orderBy: "posName",
            isAscending: true
        }

        const res = await getPositionList(payload)
        if (res?.detail === 'OK' && res?.status === 200) {

            setPositionOptions(res.data?.content.map(item => ({
                label: item.posName,
                value: item.posId,
                submissionUserFullName: item.submissionUserFullName,
                posResourceTotal: item.posResourceTotal
            })))
        } else {
            setPositionOptions([])
        }
    }

    useEffect(() => {

        fetchDataOrg().then(() => {
            fetchCheckPrivilege();
            if (isEditMode) {
                fetchGetWbsById(taskId);
            }
        });

        return () => {
            setDataField(INIT_WBS);
        };
    }, [taskId]);


    return (
        <div>
            <Card>
                {/* <Form form={form} layout="horizontal" labelCol={{ span: 2 }} wrapperCol={{ span: 16 }} labelAlign="left">
                 */}
                <Form form={form} layout="horizontal" labelAlign="left">
                    <Row gutter={[16]}>
                        <Col xs={24} sm={24} md={12}>
                            <CustomFormItemSelectDropdown
                                labelInValue={true}
                                nameFormItem="orgId"
                                label="Organization"
                                rules={[{ required: true, message: 'Please select Organization' }]}
                                loading={isLoadingOrgList}
                                options={orgOptions}
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                                disabled={true}
                                onChange={(value) => {
                                    form.setFieldsValue({ orgId: value }); // penting agar kontrol sinkron
                                    setDataField(prev => ({
                                        ...prev,
                                        orgId: value?.value || null,
                                        divId: null,
                                    }));
                                    form.setFieldsValue({ divId: undefined });
                                    if (value?.value) fetchDataDivision(value.value);
                                    else setDivOptions([]);
                                }}
                            />
                        </Col>

                        <Col xs={24} sm={24} md={12}>
                            <CustomFormItemText
                                nameFormItem="employeeName"
                                label="Nama Lengkap"
                                placeholder='Silahkan Pilih posisi'
                                rules={[
                                    {
                                        required: true,
                                    },
                                ]}
                                disabled={true}
                                value={dataField?.orgName}
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                                onChange={(e) => {
                                    setDataField(prev => ({
                                        ...prev,
                                        orgName: e.target.value
                                    }))
                                }}
                            />
                        </Col>

                        <Col xs={24} sm={24} md={12}>
                            <CustomFormItemSelectDropdown
                                nameFormItem="divId"
                                label="Division/Unit Kerja"
                                showSearch={true}
                                rules={[{ required: true }]}
                                placeholder="Select Division"
                                loading={isLoadingDivList}
                                options={divOptions}
                                labelCol={{ span: 8 }}
                                disabled={true}
                                wrapperCol={{ span: 16 }}
                                onChange={(value) => {
                                    setDataField((prev) => ({
                                        ...prev,
                                        divId: value || null,
                                        deptId: null,
                                    }));

                                    form.setFieldsValue({ deptId: undefined }); // perbaiki key yang direset
                                    if (value) {
                                        fetchDataDepartment(value);
                                    } else {
                                        setDeptOptions([]);
                                    }
                                }}
                            />
                        </Col>

                        <Col xs={24} sm={24} md={12}>
                            <CustomFormItemInteger
                                nameFormItem="posResourceTotal"
                                label="Jumlah SDM Saat Ini"
                                required={true}
                                rules={[{ required: true, message: 'Fill in Jumlah SDM Saat Ini' }]}
                                disabled={true}
                                min={1}
                                max={1000}
                                placeholder="Enter Is (1 - 1000)"
                                alignView="right" // 
                                value={dataField?.posResourceTotal}
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                                onChange={(value) => {
                                    setDataField(prev => ({
                                        ...prev,
                                        posResourceTotal: value
                                    }))
                                }}
                            />
                        </Col>
                    </Row>

                    <Row gutter={[16]}>
                        <Col xs={24} sm={24} md={12}>
                            <CustomFormItemSelectDropdown
                                nameFormItem="deptId"
                                label="Department"
                                showSearch={true}
                                value={dataField?.deptId}
                                rules={[{ required: true }]}
                                placeholder="Select Department"
                                loading={isLoadingDeptList}
                                // disabled={!dataField?.divId}
                                disabled={true}
                                options={deptOptions}
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                                onChange={(value) => {
                                    setDataField((prev) => ({
                                        ...prev,
                                        deptId: value || null,
                                        positionId: null, // reset position saat dept berubah
                                    }));

                                    form.setFieldsValue({ positionNameOption: undefined }); // reset form field

                                    if (value) {
                                        fetchDataPosition(value); // chaining
                                    } else {
                                        setPositionOptions([]);
                                    }
                                }}

                            />
                        </Col>


                        <Col xs={24} sm={24} md={12}>
                            <CustomFormItemTextArea
                                nameFormItem="orgAddress"
                                label="Lokasi Kantor"
                                required={true}
                                value={dataField?.orgAddress}
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 12 }}
                                onChange={(e) => setDataField(prev => ({ ...prev, orgAddress: e.target.value }))}
                                placeholder="Fill in Office Location"
                                disabled={true}
                            />
                        </Col>
                    </Row>

                    <Row gutter={[16]}>
                        <Col xs={24} sm={24} md={12}>
                            <CustomFormItemSelectDropdown
                                nameFormItem="posId"
                                label="Position/Jabatan"
                                showSearch={true}
                                value={dataField?.posId}
                                rules={[{ required: true }]}
                                placeholder="Select Position"
                                loading={isLoadingPosList}
                                disabled={true}
                                options={positionOptions}
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}

                                onChange={(value) => {
                                    const selected = positionOptions.find(opt => opt.value === value);
                                    setDataField(prev => ({
                                        ...prev,
                                        posId: value || null,
                                        employeeName: selected?.submissionUserFullName || "", // <-- update employee name
                                        posResourceTotal: selected?.posResourceTotal || ""
                                    }))

                                    form.setFieldsValue({
                                        employeeName: selected?.submissionUserFullName || "",
                                        posResourceTotal: selected?.posResourceTotal || ""
                                    });
                                }}
                            />
                        </Col>
                    </Row>
                    <Col xs={24}>
                        <div style={{ height: 50 }} />
                    </Col>


                    <Row gutter={[16]}>
                        <Col span={24}>
                            <SectionWbsTaskSubmission
                                taskId={taskId}
                                isView={false}
                                form={form}
                                onChangeTaskList={handleTaskListChange}
                                initialTaskList={wbsTaskList} // ✅ PASTIKAN INI BUKAN KOSONG
                            />

                        </Col>
                    </Row>

                    <div style={{ display: "flex", gap: "10px", margin: "10px 0" }}>
                        <ButtonBack onClick={() => navigate(APP_ROUTE_PREFIX + "/" + RouteConstant.task.index)} disabled={isLoadingGetById || isLoadingWbs} />
                        <ButtonSaveDraft
                            onClick={handleFormSaveDraft}
                            loading={isLoadingWbs}
                            disabled={isLoadingGetById || isLoadingWbs}
                        />
                        <ButtonSubmit
                            onClick={handleFormSubmit}
                            loading={isLoadingWbs}
                            disabled={isLoadingGetById || isLoadingWbs}
                        />
                    </div>
                </Form>
            </Card>
        </div>
    )

}
